import {
	SET_DASHBOARD_CONTAINER,
	ADD_DASHBOARD_CONTAINER,
	ADD_DASHBOARD_TO_CONTAINER,
	REMOVE_DASHBOARD_FROM_CONTAINER,
	DELETE_DASHBOARD_CONTAINER,
	UPDATE_DASHBOARD_CONTAINER
} from "../../actions/DashboardDesigner/actionContants";

const dashboardContainer = (state = [], action) => {
	switch (action.type) {
		case SET_DASHBOARD_CONTAINER:
			return action.data;
		case ADD_DASHBOARD_CONTAINER:
			return [...state, action.data];
		case ADD_DASHBOARD_TO_CONTAINER:
			var { dashboardContainerId, dashboard } = action.data;
			var targetDashboardContainerObj = state.find(e => e.id === dashboardContainerId);
			var dashboards = targetDashboardContainerObj.dashboards
				? [...targetDashboardContainerObj.dashboards, dashboard]
				: [];
			var updatedDashboardContainerObj = {
				...targetDashboardContainerObj,
				dashboards: dashboards
			};
			return state.map(dc => {
				if (dc.id === dashboardContainerId) {
					return updatedDashboardContainerObj;
				} else {
					return { ...dc };
				}
			});
		case REMOVE_DASHBOARD_FROM_CONTAINER:
			var { dashboardContainerId, dashboardId } = action.data;
			var targetDashboardContainerObj = state.find(e => e.id === dashboardContainerId);
			var dashboards = targetDashboardContainerObj.dashboards
				? targetDashboardContainerObj.dashboards.filter(e => e.id != dashboardId)
				: [];
			var updatedDashboardContainerObj = {
				...targetDashboardContainerObj,
				dashboards: dashboards
			};
			return state.map(dc => {
				if (dc.id === dashboardContainerId) {
					return updatedDashboardContainerObj;
				} else {
					return { ...dc };
				}
			});
		case DELETE_DASHBOARD_CONTAINER:
			var { dashboardContainerId } = action;
			return state.filter(obj => obj.id != dashboardContainerId);
		case UPDATE_DASHBOARD_CONTAINER:
			let tempDCState = state.map(obj => {
				if (obj.id === action.data.id) return action.data;
				else return obj;
			});
			tempDCState = _.orderBy(tempDCState, ["sortOrder"], ["asc"]);
			return tempDCState;
		default:
			return state;
	}
};

export default dashboardContainer;
